import type { FaceDetection } from 'ff-face-detection';
import { boundingBoxOf } from '../boundingBoxOf';
import { isInRange } from '../isInRange';
import { Area } from '../types/Area';
import { Size } from '../types/Size';
import { shiftCropToFaceCentered } from './shiftCropToFaceCentered';
import { sliceCropToAspect } from './sliceCropToSize';

export const sliceCropToAspectIncludeFaces = (
    cropBox: Area,
    containerAspectRatio: number,
    imageSize: Size,
    detections: FaceDetection[]
) => {

    const newCropBox = sliceCropToAspect(cropBox, containerAspectRatio);

    if (!detections || detections.length < 1) {
        return newCropBox;
    }

    const facesInCropBox = detections.filter(face => isInRange(face, cropBox));
    const faceArea = boundingBoxOf(facesInCropBox);

    if (!faceArea || isInRange(faceArea, newCropBox)) {
        return newCropBox;
    }

    return shiftCropToFaceCentered(newCropBox, detections, imageSize);
};